// 四级页面
<template>
  <div class="page">
    <!-- 背景视频 -->
    <video v-if="type==='xl'" class="video-background" id="bgVideo" autoplay muted loop>
      <source src="../../assets/bg2.mp4" type="video/mp4">
      <!-- <source src="https://s1.xiaomiev.com/activity-outer-assets/0328/images/Ultra_U/pc/ultra_2_1.mp4" type="video/mp4"> -->
      您的浏览器不支持视频标签。
    </video>
    <div class="container">
      <div v-if="type==='xl'" ref="threeContainer" class="model" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)"></div>
      <div v-else class="images">
        <img :src="deviceInfo.image"/>
      </div>
      
      <!-- 虚拟设备上下结构 -->
      <div v-if="type==='xl'" class="top_bottom">
        <div class="action">
          <div class="action_box" v-if="actionShow">
            <!-- <div class="flx-bc line line1">
              <div class="item" @click="doModel('rotate','left')">左旋</div>
              <div class="item" @click="doModel('rotate','right')">右旋</div>
            </div>
            <div class="flx-bc line">
              <div class="item" @click="doModel('scale','big')">放大</div>
              <div class="item" @click="doModel('scale','small')">缩小</div>
            </div> -->
            <div class="line" @click="$router.go(-1)">返回</div>
            <div class="line" @click="$router.push('/index')">返回首页</div>
            <div class="line" @click="doModel('reset')">复位</div>
          </div>
          <!-- <div class="action_btn" @click="actionShow=!actionShow">操作按钮</div> -->
          <div class="action_btn" @click="$router.go(-1)">返回</div>
        </div>
        <div class="flx-bc page_bottom">
          <div class="box box_l1">
            <h3 class="title">工厂概况</h3>
            <div class="info">
              <div class="intro" v-if="jsonData.info"><p v-for="(item,index) in jsonData.info.gcgk" :key="index">{{item}}</p></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">能耗统计</h3>
            <div class="main">
              <!-- <img src="/assets/image/info/nhtj.png" /> -->
              <div class="chart" id="nhtj"></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">设备监测</h3>
            <div class="main">
              <img src="/assets/image/info/sbjc.png" />
              <div class="device" :class="'device'+index" v-for="(item,index) in deviceInfo.sbjc" :key="index"><span>{{item.value}}</span></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">报警信息</h3>
            <div class="main bjxx">
              <img src="/assets/image/info/bjxx.png" />
              <div class="viewer" :class="'viewer'+index" v-for="(item,index) in deviceInfo.bjxx" :key="index"><span>{{item.value}}</span><p>{{item.name}}</p></div>
            </div>
          </div>
          <div class="box box_l2">
            <h3 class="title">监控视频</h3>
            <div class="main">
              <video v-if="deviceInfo.jksp" :src="deviceInfo.jksp" controls class="video">
                Your browser does not support the video tag.
              </video>
              <img v-else src="/assets/image/info/jksp.png" />
            </div>
          </div>
        </div>
      </div>
      <!-- 物理左右结构 -->
      <div v-else class="left_right">
        <div class="page_left">
          <div class="box box_l3" style="height:1569px">
            <h3 class="title">功能介绍</h3>
            <div class="info">
              <div class="intro">
                <p>{{deviceInfo.intro}}</p>
              </div>
            </div>
          </div>
          <div class="action" style="width:701px;height:225px">
            <div class="action_box action_box2" style="left:0">
              <div class="line" @click="$router.go(-1)">返回</div>
              <div class="line" @click="$router.push('/index')">返回首页</div>
            </div>
            <!-- <div class="action_btn" @click="actionShow=!actionShow">操作按钮</div> -->
          </div>
        </div>
        <div class="page_right">
          <div class="box box_r1">
            <h3 class="title">运行数据</h3>
            <div class="cont flx-cc" v-if="deviceInfo.yx">
              <div class="yxsj" :class="deviceInfo.yx.length>2?'four':''">
                <div class="flx-bc item" v-for="(item,index) in deviceInfo.yx" :key="index">
                  <div class="flx-lc label"><i class="icon" :class="item.icon"></i><span>{{item.name}}</span></div>
                  <span>{{item.value}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box box_r2">
            <h3 class="title">生产数据</h3>
            <div class="cont flx-cc" v-if="deviceInfo.sc">
              <div class="scsj" :class="deviceInfo.sc.length>2?'four':''">
                <div class="item" v-for="(item,index) in deviceInfo.sc" :key="index">
                  <div class="label">{{item.name}}</div>
                  <div class="flx-bc">
                    <div class="box"></div>
                    <span>{{item.value}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box box_r3">
            <h3 class="title title2">监控视频</h3>
            <div class="main">
              <video v-if="deviceInfo.jksp" :src="deviceInfo.jksp" controls class="video">
                Your browser does not support the video tag.
              </video>
              <img v-else src="/assets/image/info/jksp.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入 Three.js 核心
import * as THREE from 'three';
// 注意：从 three/examples/jsm/ 路径引入
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
// 如果需要轨道控制器
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// 环境贴图
import { DebugEnvironment } from 'three/examples/jsm/environments/DebugEnvironment.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';

import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';

import axios from 'axios'
import echarts from 'echarts'
export default {
  name: 'My3DComponent',
  components: {swiper, swiperSlide},
  data() {
    return {
      type: '',
      device: '',
      actionShow: false,
      loading: false,
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      animationId: null,
      lastRender: 0, //模型渲染
      mixer: null,
      model:null,
      scale: 1,
      rotationY: - Math.PI / 2,
      clickableObjects: [], //可点击的对象模型（代理模型）
      swiperOption: {
          loop: true,
          autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
          },
          // 显示分页
          pagination: {
              el: ".swiper-pagination",
              clickable: true //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
          }
      },
      list2: [],
      deviceInfo: {},
      obj: {
        scale: 3,
        rotationY: - Math.PI / 2
      },
      outlinePass : null,
      bloomPass: null,
      composer: null,

      jsonData: {info:''}
    };
  },
  created() {
    this.type = this.$route.query.type
    this.device = this.$route.query.device ? this.$route.query.device : ''
    if(this.type==='xl'){
      this.getData('modelXl')
    }else{
      this.getData('modelWl')
    }
    this.getData('device')
  },
  mounted() {
    if(this.type === 'xl'){
      this.loading = true
      // 延迟 100ms 等待旧 context 回收
      setTimeout(() => {
        this.initThree();
        this.loadModel();
        this.animate();
        window.addEventListener('resize', this.onWindowResize);
      }, 100);
    }
  },
  beforeDestroy() {
    // 清理 Three.js 资源，防止内存泄漏
    this.cleanUp();
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          if(name === 'modelXl'){
            this.jsonData = res.data.data
            this.jsonData.info.gcgk = this.jsonData.info.gcgk.split('\n')
            this.$nextTick(() => {
                this.echarts('nhtj')
            })
          }else if(name==='modeWl'){
              this.jsonData = res.data.data
          }else if(name==='device'){
            this.list2 = res.data.data.device
            if(this.device){
              this.deviceInfo = this.list2.find(it => it.name === this.device)
            }
          }
        }
      })
    },
    echarts(type){
        var chart = null
        let datas = []
        let dataX = []
        let names = []
        let chartData = []
        if(type==='nhtj'){
            chart = echarts.init(document.getElementById('nhtj'));
            chartData = this.jsonData.info.nhtj
        }
        dataX = chartData[0].data.map(it => it.name)
        names = chartData.map(it => it.name)
        chartData.forEach(item => {
            let data = item.data.map(it => it.value)
            datas.push({
                data: data,
                name: item.name,
                type: 'bar',
                barWidth: 20,
                label: {
                    show: true,                    // 显示标签
                    position: 'top',               // 标签显示在柱子顶部
                    fontSize: 30,
                    color: '#fff',                 // 数值颜色
                    fontWeight: 'bold',
                    // 可选：格式化显示内容
                    formatter: '{c}',// {c} 表示数值，{a}系列名，{b}类目名
                },
            })
        });
        // 清空图表
        chart.clear();
        chart.setOption({
            // 设置绘图区域的边距
            grid: {
                left: 40,   // 左侧距离
                right: 80,  // 右侧距离
                top: 100,   // 可选：顶部距离
                bottom: 40, // 可选：底部距离
                containLabel: true // 确保标签不被裁剪
            },
            legend: {
                top: 30,
                data: names,
                textStyle: {
                    fontSize: 24,
                    color: '#fff',
                    padding:[0,10],
                },
            },
            tooltip: {
                trigger: 'item',
                textStyle: {
                    color: '#fff',
                    fontSize: 24,
                },
            },
            color: ['#085ba9','#33b2e9','#33e933','#AECDFF','#FF510C','#0C85FF'],
            xAxis: {
                type: 'category',
                data: dataX,
                axisTick: {
                    show: false
                },
                axisLine: {
                  show: true,
                    lineStyle: {
                      color: '#274c8e', // 设置 x 轴线的颜色
                    }
                },
                boundaryGap: false, // 去掉左右两边的空白
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 24,   // 字体大小
                    margin: 24,
                    // rotate: 45
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                  show: true,
                    lineStyle: {
                      color: '#274c8e', // 设置 x 轴线的颜色
                    }
                },
                splitLine: { 
                    lineStyle: {
                        color: '#274c8e', // 设置 x 轴线的颜色
                    } 
                },
                axisTick: { show: false },
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 24,   // 字体大小
                    margin: 60,
                    formatter: '{value}'
                }
            },
            series: datas,
        })
    },
    // 旋转，翻转模型
    doModel(type,value){
      // 原始大小
      let obj = this.obj
      if(type === 'scale'){
        if(value==='big'){
          this.scale += 0.1
        }else{
          this.scale -= 0.1
        }
        this.model.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
      }else if(type === 'rotate'){
        if(value==='left'){
          this.rotationY -= Math.PI / 2
        }else{
          this.rotationY += Math.PI / 2
        }
        this.model.rotation.y = this.rotationY;
      }else if(type === 'reset'){
        this.model.rotation.y = obj.rotationY;
        this.model.scale.set(obj.scale, obj.scale, obj.scale);
        this.controls.reset();
      }
    },
    initThree() {
      // 创建场景
      this.scene = new THREE.Scene();
      // this.scene.background = new THREE.Color(0xffffff);
      this.scene.background = null; // 设置场景背景透明

      // 创建相机
      const width = this.$refs.threeContainer.offsetWidth;
      const height = this.$refs.threeContainer.offsetHeight;
      this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      this.scene.add(this.camera);//将相机加入到场景中
      this.camera.position.z = 10;

      // 创建渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true,alpha: true });
      this.renderer.setSize(width, height);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 1.0;
      this.renderer.setClearAlpha(0); // 设置背景透明度为0

      //Three.js 的 renderer.domElement 有时会自动获取焦点，导致媒体行为异常。可以禁用
      this.renderer.domElement.tabIndex = -1; // 防止聚焦
      this.renderer.domElement.style.outline = 'none'; // 可选：隐藏轮廓

      this.$refs.threeContainer.appendChild(this.renderer.domElement);

      
      // 使用 DebugEnvironment
      const environment = new DebugEnvironment();
      const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
      this.scene.environment = pmremGenerator.fromScene(environment).texture;
      
      // // 添加轨道控制器（可选）
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      //是否可以缩放
      this.controls.enableZoom = true;
      //是否自动旋转
      this.controls.autoRotate = false;
      // //设置相机距离原点的最远距离
      // this.controls.minDistance = 1;
      // //设置相机距离原点的最远距离
      // this.controls.maxDistance = 10;
      //是否开启右键拖拽
      this.controls.enablePan = true;

      // 添加环境光
      const ambientLight = new THREE.AmbientLight(0xffffff, .5);
      this.scene.add(ambientLight);
      // 添加平行光
      const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      directionalLight.position.set(1,1,1);
      this.scene.add(directionalLight);


// 后处理
const composer = new EffectComposer(this.renderer);
const renderPass = new RenderPass(this.scene, this.camera);
composer.addPass(renderPass);

const outlinePass = new OutlinePass(
  new THREE.Vector2(width, height),
  this.scene,
  this.camera
);
// 设置边缘辉光效果
outlinePass.edgeStrength = 8.0;     // 发光强度（亮度）
outlinePass.edgeThickness = 8.0;    // 辉光宽度（越大越“胖”）
outlinePass.edgeGlow = 0.9;         // 模糊程度（0=锐利，1=非常模糊/柔和）
outlinePass.pulsePeriod = 0;       // 无脉冲（常亮）
// 可选：辉光颜色（更柔和的蓝色）
outlinePass.visibleEdgeColor.set(0x00aaff); // 浅蓝
outlinePass.hiddenEdgeColor.set(0x0066cc);  // 内部边缘颜色（可选）
composer.addPass(outlinePass);

// 添加 Bloom泛光 效果（让发光更明显）
// const bloomPass = new UnrealBloomPass(
//   new THREE.Vector2(width, height),
//   1.0,   // 发光强度
//   0.6,   // 模糊半径
//   0.7    // 阈值
// );
// // 调高 threshold，只让最亮的部分泛光
// bloomPass.threshold = 0.8;  // 只有亮度 > 80% 的才发光
// bloomPass.strength = 1.5;
// bloomPass.radius = 0.4;
// composer.addPass(bloomPass);

this.composer = composer
this.outlinePass = outlinePass
// this.bloomPass = bloomPass
    },
    loadModel() {
      const gltfLoader = new GLTFLoader();
      let url = `/assets/3d/${this.device}.glb`
      this.obj.scale = 3
      switch(this.device){
        case '除尘器':
          this.obj.scale = 1.4
          break;
        case '粉碎机组':
          this.obj.scale = 1.5
          break;
        case '干燥塔':
          this.obj.scale = 1.8
          break;
        case '缓冲罐':
          this.obj.scale = 1.8
          break;
        case '混料机':
          this.obj.scale = 1.4
          break;
        case '净乳机':
          this.obj.scale = 2.5
          break;
        case '螺旋输送机':
          this.obj.scale = 1.5
          break;
        case '灭菌机':
          this.obj.scale = 2.3
          break;
        case '凝乳罐':
          this.obj.scale = 1.5
          break;
        case '溶解罐':
          this.obj.scale = 1.25
          break;
        case '湿法破碎机':
          this.obj.scale = 1.8
          break;
        case '脱脂机':
          this.obj.scale = 2
          break;
        case '原料粉碎':
          this.obj.scale = 1.5
          break;
        case '自动包装机':
          this.obj.scale = 2
          break;
      }
      // 加载 .glb 文件
      gltfLoader.load(
        url, 
        (gltf) => {
          // 模型加载成功
          console.log('模型加载成功:', gltf);
          const model = gltf.scene;
          model.scale.set(this.obj.scale,this.obj.scale,this.obj.scale);
          model.rotation.y = - Math.PI / 2;
          model.rotation.x = 0.5
          model.position.set(0,1,0)

          const targetObjects = []; //边缘发光的物体
          model.traverse((child) => {
            if (child.isMesh) {
                if(child.name.indexOf(this.device)>-1){
                  // 生成描边
                  // const edges = new THREE.EdgesGeometry(child.geometry, 15); // 阈值50度,值越小，线条越多
                  // const line = new THREE.LineSegments(
                  //     edges,
                  //     new THREE.LineBasicMaterial({ color: 0x31DEEF, linewidth: 2 })
                  // );
                  // child.add(line);
                  // 增强自发光
                  child.material.emissive = child.material.emissive || new THREE.Color();
                  // child.material.color.set(0x548ecb);// 表面颜色（受光照）
                  child.material.emissive.set(0x548ecb);// 自发光（不受光照）
                  child.material.emissiveIntensity = 1;
                  targetObjects.push(child);
                }else{
                  child.material.color.set(0xcccccc);
                }
              }
          });
          this.outlinePass.selectedObjects = targetObjects; // 设置辉光对象
          // this.bloomPass.selectedObjects = targetObjects

          this.scene.add(model)
          this.model = model
          this.loading = false
          
          // 获取动画混合器
          const animations = gltf.animations;
          if (animations && animations.length) {
            this.mixer = new THREE.AnimationMixer(gltf.scene);
            for (let i = 0; i < animations.length; i++) {
              const action = this.mixer.clipAction(animations[i]);
              action.play();
            }
          }
        },
        (xhr) => {
          // 加载进度回调
          // console.log('模型加载进度:', (xhr.loaded / xhr.total * 100) + '% loaded');
        },
        (error) => {
          // 加载错误回调
          console.error('模型加载失败:', error);
        }
      );
    },
    // 不需要每帧都渲染（尤其是静态场景）：
    animate(time) {
      this.animationId = requestAnimationFrame(this.animate);
      // 限制渲染频率
      const TARGET_FPS = 30;
      if (time - this.lastRender < 1000 / TARGET_FPS) return;
      this.lastRender = time;

      // 更新动画
      if (this.mixer) {
        this.mixer.update(0.05);
      }
      // 更新控制器
      if (this.controls) {
        this.controls.update();
      }
      // 渲染场景
      this.renderer.render(this.scene, this.camera);

      // 使用 composer 渲染（自动处理多 pass）
      this.composer.render();
    },
    onClick(event) {
      const rect = this.renderer.domElement;
      const mouse = new THREE.Vector2(
        (event.offsetX / rect.clientWidth) * 2 - 1,
        -(event.offsetY / rect.clientHeight) * 2 + 1
      );
      // 设置射线
      const raycaster = new THREE.Raycaster()
      raycaster.setFromCamera(mouse, this.camera);
      raycaster.firstHitOnly = true;
      // 检测相交的对象，只考虑Mesh类型，并且限定为模型及其子对象
      const intersects = raycaster.intersectObjects(this.clickableObjects, true).filter(intersect => intersect.object instanceof THREE.Mesh);
      if (intersects.length > 0) {
        const target = intersects[0].object; // 代理对象
        console.log(target)
      }
    },
    onWindowResize() {
      const container = this.$refs.threeContainer;
      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
    },
    cleanUp() {
      console.log("清理 Three.js 资源，防止内存泄漏")
      // 清理资源
      window.removeEventListener('resize', this.onWindowResize);
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      if (this.controls) {
        this.controls.dispose();
        this.controls = null;
      }
      if (this.composer) {
        this.composer.renderTarget1.dispose();
        this.composer.renderTarget2.dispose();
        this.composer = null;
      }
      if (this.outlinePass) {
        if (this.outlinePass.renderTarget1) this.outlinePass.renderTarget1.dispose();
        if (this.outlinePass.renderTarget2) this.outlinePass.renderTarget2.dispose();
        this.outlinePass = null;
      }
      if (this.bloomPass) {
        if (this.bloomPass.renderTarget1) this.bloomPass.renderTarget1.dispose();
        if (this.bloomPass.renderTarget2) this.bloomPass.renderTarget2.dispose();
        this.bloomPass = null;
      }
      if(this.model){
        this.disposeModel(this.model)
        this.model = null
      }
      if (this.scene) {
        this.scene.clear();
        this.scene = null;
      }
      this.camera = null;
      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        const canvas = this.renderer.domElement;
        if (canvas && canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
        }
        this.renderer = null;
      }
    },
    // 切换模型时销毁的 THREE.Mesh 或其父级 Group
    disposeModel(model) {
      // 遍历模型中的所有子对象
      model.traverse((child) => {
          if (child.isMesh) { // 如果是网格
              // 1. 释放几何体
              if (child.geometry) {
                  child.geometry.dispose();
              }
              // 2. 释放 material 和 textures
              if (child.material) {
                const materials = Array.isArray(child.material) ? child.material : [child.material];
                materials.forEach(mat => {
                  // 手动释放所有纹理
                  ['map', 'normalMap', 'emissiveMap', 'roughnessMap'].forEach(key => {
                    if (mat[key] && mat[key].isTexture) {
                      mat[key].dispose();
                    }
                  });
                  mat.dispose(); // 最后释放材质
                });
              }
          }
      });
      // 3. 从场景中移除该模型
      this.scene.remove(model);
    }
  },
};
</script>

<style lang="less" scoped>
@import '@/styles/subpage';
@import '@/styles/detail';
@import '@/styles/info';
.chart{
  width: 100%;
  height: 100%;
}
.main{
  position: relative;
  .device{
    position: absolute;
    width: 140px;
    height: 170px;
    padding-top: 85px;
    text-align: center;
    span{
      font-weight: bold;
    }
  }
  .device0{
    left: 60px;
    top: 80px;
  }
  .device1{
    left: 288px;
    top: 80px;
  }
  .device2{
    left: 526px;
    top: 80px;
  }
  .device3{
    left: 60px;
    top: 344px;
  }
  .device4{
    left: 288px;
    top: 344px;
  }
  .device5{
    left: 526px;
    top: 344px;
  }
  .viewer{
    position: absolute;
    width: 200px;
    height: 200px;
    padding-top: 45px;
    text-align: center;
    // background: #000;
    // opacity: 0.5;
    span{
      font-weight: bold;
      color:#fff600;
    }
    p{
      color: #fff;
      margin-top: 60px;
    }
  }
  .viewer0{
    left: 63px;
    top: 23px;
  }
  .viewer1{
    left: 264px;
    top: 23px;
  }
  .viewer2{
    left: 455px;
    top: 23px;
  }
  .viewer3{
    left: 63px;
    top: 244px;
  }
  .viewer4{
    left: 264px;
    top: 244px;
  }
  .viewer5{
    left: 455px;
    top: 244px;
  }
}
.bjxx{
  .viewer0{
    left: 54px;
  }
  .viewer1{
    left: 255px;
  }
  .viewer2{
    left: 446px;
  }
  .viewer3{
    left: 54px;
    top: 255px;
  }
  .viewer4{
    left: 255px;
    top: 255px;
  }
  .viewer5{
    left: 446px;
    top: 255px;
  }
}
.top_bottom{
  .main{
    .device{
      width: 126px;
      height: 148px;
      padding-top: 72px;
      font-size: 26px;
    }
    .device0{
      left: 78px;
      top: 60px;
    }
    .device1{
      left: 282px;
      top: 60px;
    }
    .device2{
      left: 495px;
      top: 60px;
    }
    .device3{
      left: 78px;
      top: 266px;
    }
    .device4{
      left: 282px;
      top: 266px;
    }
    .device5{
      left: 495px;
      top: 266px;
    }
  }
}
.video{
  width: 100%;
  height: 100%;
}
</style>